var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactElementFactory } from "../element-factory";
import { ScrollViewModel } from "survey-core";
var Scroll = /** @class */ (function (_super) {
    __extends(Scroll, _super);
    function Scroll(props) {
        var _this = _super.call(this, props) || this;
        _this.rootRef = React.createRef();
        _this.model = new ScrollViewModel();
        _this.model.onInnerHeightChanged = function (hasScroll) {
            if (!!_this.props.onInnerHeightChanged) {
                _this.props.onInnerHeightChanged(hasScroll);
            }
        };
        return _this;
    }
    Scroll.prototype.componentDidMount = function () {
        var container = this.rootRef.current;
        if (!container)
            return;
        this.model.setRootElement(container);
    };
    Scroll.prototype.componentWillUnmount = function () {
        this.model.unsubscribeRootElement();
        this.model.setRootElement(undefined);
    };
    Scroll.prototype.render = function () {
        var _this = this;
        return this.props.disabled ?
            React.createElement(React.Fragment, null, this.props.children) :
            React.createElement("div", { ref: this.rootRef, className: "sv-scroll__wrapper" },
                React.createElement("div", { className: "sv-scroll__scroller sv-drag-target-skipped", onScroll: function () { return _this.model.onScrollContainer(); } },
                    React.createElement("div", { className: "sv-scroll__container" }, this.props.children)),
                React.createElement("div", { className: "sv-scroll__scrollbar", onScroll: function () { return _this.model.onScrollScrollbar(); } },
                    React.createElement("div", { className: "sv-scroll__scrollbar-sizer" })));
    };
    return Scroll;
}(React.Component));
export { Scroll };
ReactElementFactory.Instance.registerElement("svc-scroll", function (props) {
    return React.createElement(Scroll, props);
});
